import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import VueAxios from "vue-axios";
import _accessApi from "@/router/_accessApi.js";


// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");

// Views
const DashboardCro = () => import("@/views/DashboardCro");
const DashboardAsset = () => import("@/views/DashboardAsset");
const DashboardHrd = () => import("@/views/DashboardHrd");
const DashboardProfile = () => import("@/views/DashboardProfile");
const DashboardCustomer = () => import("@/views/DashboardCustomer");
const Dashboard = () => import("@/views/Dashboard");
const DashboardRecapRo = () => import("@/views/DashboardRecapRo");
const DashboardRecapWarehouse = () => import("@/views/DashboardRecapWarehouse");
const DashboardPerformanceRo = () => import("@/views/DashboardPerformanceRo");
const DashboardSPKBGenerated = () => import("@/views/DashboardSPKBGenerated");
const DashboardCustomerHistoryOrder = () => import("@/views/DashboardCustomerHistoryOrder");
const DashboardPiutangCustomer = () => import("@/views/DashboardPiutangCustomer");
const DashboardPiutangCustomerSummary = () => import("@/views/DashboardPiutangCustomerSummary");
const DashboardPerformanceCustomer = () => import("@/views/DashboardPerformanceCustomer");
const DashboardLeads = () => import("@/views/DashboardLeads");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const ChangePassword = () => import("@/views/changepassword/changepassword")
//const Login = () => import('@/views/pages/Login')
const Register = () => import("@/views/pages/Register");
const NotFound = () => import("@/views/notfound/NotFound");
const Login = () => import("@/views/login/Login");
const PrivacyPolicy = () => import("@/views/login/PrivacyPolicy");

//agi
const Mitra = () => import("@/views/md/MitraDC");
const ScheduleMitra = () => import("@/views/md/ScheduleMitra");
const Spkb = () => import("@/views/spkb/Spkb");
const SpkbDetail = () => import("@/views/spkb/SpkbDetail");
const SpkbAdjust = () => import("@/views/spkb/SpkbAdjust");
const SpkbAdjustDetail = () => import("@/views/spkb/SpkbAdjustDetail");
const SpkbBpb = () => import("@/views/spkb/SpkbBpb");
const SpkbBpbDetail = () => import("@/views/spkb/SpkbBpbDetail");
const SpkbExchange = () => import("@/views/spkb/SpkbExchange");


const Orders = () => import("@/views/order/Order");
const OrderDetails = () => import("@/views/order/OrderDetails");
const Customer = () => import("@/views/customer/Customer");
const CustomerDetails = () => import("@/views/customer/CustomerDetails");
const CustomerNonactive = () => import("@/views/customer/CustomerNonActive");
const CustomerNonactiveDetails = () => import("@/views/customer/CustomerNonActiveDetails");
const CustomerRouteNonGT = () => import("@/views/customer/CustomerRouteNonGT");
const CustomerRouteNonGTDetail = () => import("@/views/customer/CustomerRouteNonGTDetail");
const CustomerTrackingOrder = () => import("@/views/customer/CustomerTrackingOrder");
const CustomerSurvey = () => import("@/views/customer/CustomerSurvey");
const CustomerSurveyDetail = () => import("@/views/customer/CustomerSurveyDetail");
const Noo = () => import("@/views/customer/Noo");
const NooDetail = () => import("@/views/customer/NooDetail");

const Product = () => import("@/views/product/Product");
const ProductDetails = () => import("@/views/product/ProductDetails");
const Employee = () => import("@/views/employee/Employee");
const EmployeeDetails = () => import("@/views/employee/EmployeeDetails");
const EmployeeAttendance = () => import("@/views/employee/EmployeeAttendance");
const VerificationAttendance = () => import("@/views/employee/VerificationAttendance");

const Zone = () => import("@/views/master/zone/Zone");
const CustomerGroup = () => import("@/views/master/customer_group/CustomerGroup");
const AssetOwner = () => import("@/views/master/assets/AssetOwner");
const Asset = () => import("@/views/master/assets/Asset");
const AssetStatus = () => import("@/views/master/asset_status/AssetStatus");
const EmployeeDivision = () => import("@/views/master/employee/EmployeeDivision");
const EmployeePosition = () => import("@/views/master/employee/EmployeePosition");
const EmployeePaymentMethod = () => import("@/views/master/employee/EmployeePaymentMethod");
const EmployeeHeadOffice = () => import("@/views/master/employee/EmployeeHeadOffice");
const EmployeeStatus = () => import("@/views/master/employee/EmployeeStatus");
const EmployeeInquiry = () => import("@/views/employee/EmployeeInquiry");
const EmployeeInquiryDetail = () => import("@/views/employee/EmployeeInquiryDetail");
const EmployeeAdvance = () => import("@/views/employee/EmployeeAdvance");
const EmployeeAdvanceDetail = () => import("@/views/employee/EmployeeAdvanceDetail");
const EmployeeLogs = () => import("@/views/employee/EmployeeLogs");
const EmployeeSalary = () => import("@/views/employee/EmployeeSalary");
const DriverReport = () => import("@/views/employee/DriverReport");


const BillingAddress = () => import("@/views/master/billing_address/BillingAddress");
const Route = () => import("@/views/master/route/Route");
const MenuAccess = () => import("@/views/master/access_menu/AccessMenu");
const VehicleDelivery = () => import("@/views/master/vehicle/VehicleDelivery");
const ProductsGroup = () => import("@/views/master/product/ProductsGroup");

const DistributionCenter = () => import("@/views/distribution_center/DistributionCenter");
const DistributionCenterDetail = () => import("@/views/distribution_center/DistributionCenterDetail");

const ExportPoIndomaret = () => import("@/views/export/PoIndomaret");
const ExportDataCustomer = () => import("@/views/export/Customer");
const ExportDataEmployee = () => import("@/views/export/Employee");
const ExportDataEmployeeAttendance = () => import("@/views/export/EmployeeAttendance");
const ExportDataOrderHistory = () => import("@/views/export/OrderHistory");
const ExportDataSpkbDelivery = () => import("@/views/export/SpkbDelivery");
const ExportDataSpkbPiutang = () => import("@/views/export/SpkbPiutang");
const ExportDataPiutang = () => import("@/views/export/DataPiutang");
const ExportTotalBoxInCar = () => import("@/views/export/BoxInCar");
const ExportSoldProduct = () => import("@/views/export/SummarySoldProduct");
const ExportDataAssets = () => import("@/views/export/Assets");
const ExportProductPrice = () => import("@/views/export/ProductPrice");
const ExportOrderNonRelatedToSpkb = () => import("@/views/export/OrderNonRelatedToSpkb");
const ExportSummaryAllSoldProduct = () => import("@/views/export/SummaryAllSoldProduct");
const ExportTaskCro = () => import("@/views/export/ExportTaskCro");
const ExportCustomerLatLong = () => import("@/views/export/ExportCustomerLatLong");
const ExportHistoryAllOrder = () => import("@/views/export/ExportHistoryAllOrder");
const ExportDataEmployeeAttendanceWithDistance = () => import("@/views/export/EmployeeAttendanceWithDistance");
const ExportSummaryFreezer = () => import("@/views/export/SummaryFreezer");
const ExportCustomerHistory = () => import("@/views/export/ExportHistoryCustOrder");
const ExportSpkbHistory = () => import("@/views/export/SpkbHistory");
const ExportCustomerSurvey = () => import("@/views/export/ExportCustomerSurvey");
const ExportLeads = () => import("@/views/export/ExportLeads");

const FreezerLocation = () => import("@/views/freezer/FreezerLocation");

const GenerateSpkbIndomaret = () => import("@/views/generate/SpkbIndomaret");

const CroTask = () => import("@/views/cro/Task");
const CroTaskDetail = () => import("@/views/cro/TaskDetail");

const CvoTask = () => import("@/views/cvo/Task");
const CvoTaskDetail = () => import("@/views/cvo/TaskDetail");

//cvo
const DeliveryCustomer = () => import("@/views/cvo/DeliveryCustomer");
const VisitCustomer = () => import("@/views/cvo/VisitCustomer");
const CvoDetailActivityVisit = () => import("@/views/cvo/CvoDetailActivityVisit");
const CvoDetailActivityDelivery = () => import("@/views/cvo/CvoDetailActivityDelivery");


const CroTaskMigration = () => import("@/views/cro/TaskMigration");
const CroTaskMigrationDetail = () => import("@/views/cro/TaskMigrationDetail");


const CalculateSo = () => import("@/views/widgets/CalculateSo");

const Warehouse = () => import("@/views/warehouse/Warehouse");
const WarehouseDetail = () => import("@/views/warehouse/WarehouseDetail");
const WarehouseHistory = () => import("@/views/warehouse/WarehouseHistory");
const ProductReturn = () => import("@/views/product/ProductReturn");
const ProductReturnDetail = () => import("@/views/product/ProductReturnDetail");

const FinancePiutang = () => import("@/views/finance/Piutang");
const FinancePiutangDetail = () => import("@/views/finance/PiutangDetail");
const FinancePayment = () => import("@/views/finance/Payment");
const FinancePaymentTempo = () => import("@/views/finance/PaymentTempo");
const FinancePiutangAdjustmentActual = () => import("@/views/finance/PiutangAdjustmentActual");
const FinancePiutangAdjustmentRetur = () => import("@/views/finance/PiutangAdjustmentRetur");

const MitraCoverage = () => import("@/views/mitra/MitraCoverage");

const SPKBLunas = () => import("@/views/accounting/SPKBLunas");
const SPKBLunasDetail = () => import("@/views/accounting/SPKBLunasDetail");

const SurveyFreezer = () => import("@/views/surveyor/freezer/SurveyFreezer");
const SurveyFreezerDetail = () => import("@/views/surveyor/freezer/SurveyFreezerDetail");

const RequestFreezer = () => import("@/views/assets/RequestFreezer");
const RequestFreezerDetail = () => import("@/views/assets/RequestFreezerDetail");

const BankBook = () => import("@/views/bank_book/BankBook");
const BankBookDetail = () => import("@/views/bank_book/BankBookDetail");

const Leads = () => import("@/views/leads/Leads");
const LeadsDetail = () => import("@/views/leads/LeadsDetail");

const VerificationTemplate = () => import("@/views/master/template/VerificationTemplate");
const VerificationWorking = () => import("@/views/master/template/VerificationWorking");
const VerificationAgreementFreezer = () => import("@/views/master/template/VerificationAgreementFreezer");

Vue.use(Router);

export const router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: "*", component: NotFound },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/privacy-policy",
      name: "Privacy Policy",
      component: PrivacyPolicy
    },
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard-cro",
          name: "Dashboard CRO",
          component: DashboardCro
        },
        {
          path: "dashboard-asset",
          name: "Dashboard Asset",
          component: DashboardAsset
        },
        {
          path: "dashboard-hrd",
          name: "Dashboard HRD",
          component: DashboardHrd
        },
        {
          path: "dashboard-profile",
          name: "Dashboard Profile",
          component: DashboardProfile
        },
        {
          path: "dashboard-customer",
          name: "Dashboard Customer",
          component: DashboardCustomer
        },
        {
          path: "dashboard-recap-ro",
          name: "Dashboard Recap Ro",
          component: DashboardRecapRo
        },
        {
          path: "dashboard-recap-warehouse",
          name: "Dashboard Recap Warehouse",
          component: DashboardRecapWarehouse
        },
        {
          path: "dashboard-performance-ro",
          name: "Dashboard Performance RO",
          component: DashboardPerformanceRo
        },
        {
          path: "dashboard-spkb-generated",
          name: "Dashboard SPKB Generated",
          component: DashboardSPKBGenerated
        },
        {
          path: "dashboard-history-customer",
          name: "Dashboard History Customer",
          component: DashboardCustomerHistoryOrder
        },
        {
          path: "dashboard-piutang-customer",
          name: "Dashboard piutang Customer",
          component: DashboardPiutangCustomer
        },
        {
          path: "dashboard-piutang-customer-summary",
          name: "Dashboard piutang Customer Summary",
          component: DashboardPiutangCustomerSummary
        },
        {
          path: "dashboard-performance-customer",
          name: "Dashboard Performance Customer",
          component: DashboardPerformanceCustomer
        },
        {
          path: "dashboard-leads",
          name: "Dashboard Leads",
          component: DashboardLeads
        },
        {
          path: "order",
          redirect: "/order/all",
          name: "Orders",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Order Listing",
              component: Orders
            },
            {
              path: "all/detail/:id",
              name: "Order Details",
              component: OrderDetails,
              props: true
            }
          ]
        },
        {
          path: "spkb",
          redirect: "/spkb/all",
          name: "SPKB",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "SPKB Listing",
              component: Spkb
            },
            {
              path: "all/detail/:id",
              name: "SPKB Details",
              component: SpkbDetail,
              props: true
            }
          ]
        },
        {
          path: "spkb-adjust",
          redirect: "/spkb-adjust/all",
          name: "Qty Actual",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "All Ready for SPKB",
              component: SpkbAdjust
            },
            {
              path: "all/detail/:id",
              name: "SPKB Set Qty Actual",
              component: SpkbAdjustDetail,
              props: true
            }
          ]
        },
        {
          path: "spkb-bpb",
          redirect: "/spkb-bpb/all",
          name: "Qty BPP Final",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "All SPKB Ready to set BPB Final",
              component: SpkbBpb
            },
            {
              path: "all/detail/:id",
              name: "SPKB Set Qty BPB Final",
              component: SpkbBpbDetail,
              props: true
            }
          ]
        },
        {
          path: "spkb-exchange",
          redirect: "/spkb-exchange/all",
          name: "Tukar SPKB",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Find SPKB Exchange",
              component: SpkbExchange
            }
          ]
        },
        {
          path: "customer",
          redirect: "/customer/all",
          name: "Customer",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Customer Listing",
              component: Customer
            },
            {
              path: "all/detail/:id",
              name: "Customer Details",
              component: CustomerDetails,
              props: true
            }
          ]
        },
        {
          path: "customer-survey",
          redirect: "/customer-survey/all",
          name: "Customer Survey",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Customer Survey Listing",
              component: CustomerSurvey
            },
            {
              path: "all/detail/:id",
              name: "Customer Survey Details",
              component: CustomerSurveyDetail,
              props: true
            }
          ]
        },
        {
          path: "noo",
          redirect: "/noo/all",
          name: "NOO",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "NOO Listing",
              component: Noo
            },
            {
              path: "all/detail/:id",
              name: "NOO Details",
              component: NooDetail,
              props: true
            }
          ]
        },
        {
          path: "customer-nonactive",
          redirect: "/customer-nonactive/all",
          name: "Customer Non Active",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Customer Non Active Listing",
              component: CustomerNonactive
            },
            {
              path: "all/detail/:id",
              name: "Customer Non Active Details",
              component: CustomerNonactiveDetails,
              props: true
            }
          ]
        },
        {
          path: "customer-tracking-order",
          name: "Customer Tracking Order",
          component: CustomerTrackingOrder
        },
        {
          path: "mitra",
          redirect: "/mitra/coverage/all",
          name: "Mitra",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "coverage/all",
              name: "Mitra Coverage",
              component: MitraCoverage
            }
          ]
        },
        {
          path: "cvo",
          redirect: "/cvo/all",
          name: "CVO",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Tugas CVO",
              component: CvoTask
            },
            {
              path: "all/detail/:id",
              name: "Tugas CVO Details",
              component: CvoTaskDetail,
              props: true
            }
          ]
        },
        {
          path: "cro",
          redirect: "/cro/all",
          name: "CRO",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Tugas CRO",
              component: CroTask
            },
            {
              path: "all/detail/:id",
              name: "Tugas CRO Details",
              component: CroTaskDetail,
              props: true
            }
          ]
        },
        {
          path: "cro-task-migration",
          redirect: "/cro-task-migration/all",
          name: "CRO Task Migration",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Pindah Delegasi Tugas CRO",
              component: CroTaskMigration
            },
            {
              path: "all/detail/:id",
              name: "Pindah Delegasi Tugas CRO Details",
              component: CroTaskMigrationDetail,
              props: true
            }
          ]
        },
        {
          path: "route_non_gt",
          redirect: "/route_non_gt/all",
          name: "Rute Non GT",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Listing",
              component: CustomerRouteNonGT
            },
            {
              path: "all/detail/:id",
              name: "Route Non GT Details",
              component: CustomerRouteNonGTDetail,
              props: true
            }
          ]
        },
        {
          path: "employee",
          redirect: "/employee/all",
          name: "Employee",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Employee Listing",
              component: Employee
            },
            {
              path: "all/detail/:id",
              name: "Employee Details",
              component: EmployeeDetails,
              props: true
            },
            {
              path: "attendance",
              name: "Employee Attendance",
              component: EmployeeAttendance
            },
            {
              path: "verification-attendance",
              name: "Verification Attendance",
              component: VerificationAttendance
            },
            {
              path: "driver-report",
              name: "Driver Report",
              component: DriverReport
            }
          ]
        },
        {
          path: "employee-inquiry",
          redirect: "/employee-inquiry/all",
          name: "Employee Inquiry",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Employee Inquiry Listing",
              component: EmployeeInquiry
            },
            {
              path: "all/detail/:id",
              name: "Employee Inquiry Details",
              component: EmployeeInquiryDetail,
              props: true
            }
          ]
        },
        {
          path: "employee-advance",
          redirect: "/employee-advance/all",
          name: "Employee Advance",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Employee Advance Listing",
              component: EmployeeAdvance
            },
            {
              path: "all/detail/:id",
              name: "Employee Advance Details",
              component: EmployeeAdvanceDetail,
              props: true
            }
          ]
        },
        {
          path: "employee-logs",
          redirect: "/employee-logs/all",
          name: "Employee Logs",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Employee Logs Listing",
              component: EmployeeLogs
            }
          ]
        },
        {
          path: "employee-task-verification",
          redirect: "/employee-task-verification/all",
          name: "Employee Task Verification",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Employee Verification Task Listing",
              component: VerificationWorking
            }
          ]
        },
        {
          path: "employee-task-verification-freezer",
          redirect: "/employee-task-verification-freezer/all",
          name: "Employee Verification Task Agreement",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Employee Verification Agreement Listing",
              component: VerificationAgreementFreezer
            }
          ]
        },
        {
          path: "employee-salary",
          name: "Employee Salary",
          component: EmployeeSalary
        },
        {
          path: "product",
          redirect: "/product/all",
          name: "Product",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Product Listing",
              component: Product
            },
            {
              path: "all/detail/:id",
              name: "Product Details",
              component: ProductDetails,
              props: true
            }
          ]
        },
        {
          path: "product-return",
          redirect: "/product-return/all",
          name: "Return",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Complete SPKB",
              component: ProductReturn
            },
            {
              path: "all/detail/:id",
              name: "Complete SPKB Detail",
              component: ProductReturnDetail,
              props: true
            }
          ]
        },
        {
          path: "finance-piutang",
          redirect: "/finance-piutang/all",
          name: "Finance Piutang",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "List Piutang",
              component: FinancePiutang
            },
            {
              path: "all/detail/:id",
              name: "Piutang Detail",
              component: FinancePiutangDetail,
              props: true
            },
            {

              path: "all/adjustment-actual/:id",
              name: "Piutang Adjustment Actual Detail",
              component: FinancePiutangAdjustmentActual,
              props: true
            },
            {

              path: "all/adjustment-retur/:id",
              name: "Piutang Adjustment Retur Detail",
              component: FinancePiutangAdjustmentRetur,
              props: true
            }
          ]
        },
        {
          path: "finance-payment",
          redirect: "/finance-payment/doPayment",
          name: "Finance Payment",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "doPayment",
              name: "Buat Pembayaran",
              component: FinancePayment
            }
          ]
        },
        {
          path: "finance-payment-tempo",
          redirect: "/finance-payment-tempo/doPaymentTempo",
          name: "Finance Payment Tempo",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "doPaymentTempo",
              name: "Buat Pembayaran Tempo",
              component: FinancePaymentTempo
            }
          ]
        },
        {
          path: "warehouse",
          name: "Gudang",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Daftar Gudang",
              component: Warehouse
            },
            {
              path: "all/detail/:id",
              name: "Warehouse Details",
              component: WarehouseDetail,
              props: true
            },
            ,
            {
              path: "history/all",
              name: "Riwayat Warehouse",
              component: WarehouseHistory,
              props: true
            }
          ]
        },
        {
          path: "distribution_center",
          redirect: "/distribution_center/all",
          name: "Distribution Center",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "DC Listing",
              component: DistributionCenter
            },
            {
              path: "all/detail/:id",
              name: "DC Details",
              component: DistributionCenterDetail,
              props: true
            }
          ]
        },
        {
          path: "leads",
          redirect: "/leads/all",
          name: "Leads",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Leads Listing",
              component: Leads
            },
            {
              path: "all/detail/:id",
              name: "Leads Details",
              component: LeadsDetail,
              props: true
            }
          ]
        },
        {
          path: "master",
          redirect: "/master/employees",
          name: "Master",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "employees",
              name: "Karyawan",
              redirect: "/master/employees/division",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "division",
                  name: "Divisi",
                  component: EmployeeDivision
                },
                {
                  path: "position",
                  name: "Jabatan",
                  component: EmployeePosition
                },
                {
                  path: "payment_method",
                  name: "Metode Pembayaran",
                  component: EmployeePaymentMethod
                },
                {
                  path: "head_office",
                  name: "Head Office",
                  component: EmployeeHeadOffice
                },
                {
                  path: "employee_status",
                  name: "Status Karyawan",
                  component: EmployeeStatus
                }
              ]
            },
            {
              path: "zone",
              name: "Zona",
              component: Zone
            },
            {
              path: "route",
              name: "Route",
              component: Route
            },
            {
              path: "billing_address",
              name: "Alamat Penagihan",
              component: BillingAddress
            },
            {
              path: "customer-group",
              name: "Group Konsumen",
              component: CustomerGroup
            },
            {
              path: "products-group",
              name: "Products Group",
              component: ProductsGroup
            },
            {
              path: "assets",
              name: "Assets",
              redirect: "/master/asset/owner",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "owner",
                  name: "Asset Owner",
                  component: AssetOwner
                },
                {
                  path: "all",
                  name: "Asset Barang",
                  component: Asset
                }
              ]
            },
            {
              path: "menu-access",
              name: "Menu Access",
              component: MenuAccess
            },
            {
              path: "asset-status",
              name: "Asset Status",
              component: AssetStatus
            },
            {
              path: "vehicle-delivery",
              name: "Vehicle Delivery",
              component: VehicleDelivery
            },
            {
              path: "verification-template",
              name: "Verification Template",
              component: VerificationTemplate
            },
          ]
        },
        {
          path: "export",
          name: "Export",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "po_indomaret",
              name: "PO Indomaret",
              component: ExportPoIndomaret
            },
            {
              path: "data-customer",
              name: "Data Konsumen",
              component: ExportDataCustomer
            },
            {
              path: "data-employee",
              name: "Data Kayawan",
              component: ExportDataEmployee
            },
            {
              path: "data-employee-attendance",
              name: "Data Absensi Kayawan",
              component: ExportDataEmployeeAttendance
            },
            {
              path: "data-order-history",
              name: "Rekap Order",
              component: ExportDataOrderHistory
            },
            {
              path: "data-spkb-delivery",
              name: "Spkb Delivery",
              component: ExportDataSpkbDelivery
            },
            {
              path: "data-spkb-piutang",
              name: "Spkb Piutang",
              component: ExportDataSpkbPiutang
            },
            {
              path: "data-piutang",
              name: "Piutang",
              component: ExportDataPiutang
            },
            {
              path: "total-box-in-car",
              name: "Total Box In Car",
              component: ExportTotalBoxInCar
            },
            {
              path: "summary-sold-product",
              name: "Rekap Produk Yang Terjual",
              component: ExportSoldProduct
            },
            {
              path: "data-assets",
              name: "Export Data Assets",
              component: ExportDataAssets
            },
            {
              path: "product-price",
              name: "Export Harga Produk",
              component: ExportProductPrice
            },
            {
              path: "order-non-related-to-spkb",
              name: "Order Non Related To SPKB",
              component: ExportOrderNonRelatedToSpkb
            },
            {
              path: "summary-sold-all-product",
              name: "Rekap Semua Produk Yang Terjual",
              component: ExportSummaryAllSoldProduct
            },
            {
              path: "list-task-cro",
              name: "Export Task CRO",
              component: ExportTaskCro
            },
            {
              path: "export-customer-lat-long",
              name: "Data Konsumen Dengan Lat Long",
              component: ExportCustomerLatLong
            },
            {
              path: "export-history-all-order",
              name: "History All Order",
              component: ExportHistoryAllOrder
            },
            {
              path: "export-all-employee-to-pdf",
              name: "Export All Employee To PDF With Distance",
              component: ExportDataEmployeeAttendanceWithDistance
            },
            {
              path: "summary-freezer",
              name: "Summary All Freezer",
              component: ExportSummaryFreezer
            },
            {
              path: "customer-history-order",
              name: "Customer History Order",
              component: ExportCustomerHistory
            },
            {
              path: "export-spkb-history",
              name: "Export SPKB History",
              component: ExportSpkbHistory
            },
            {
              path: "export-customer-survey",
              name: "Export Customer Survey",
              component: ExportCustomerSurvey
            },
            {
              path: "export-leads",
              name: "Export Leads",
              component: ExportLeads
            }
          ]
        },
        {
          path: "widgets",
          name: "Widgets",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "calculate_so",
              name: "Calculate SO",
              component: CalculateSo
            }
          ]
        },
        {
          path: "accounting",
          name: "Accounting",
          redirect: "/accounting/spkb-complete-payment",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "spkb-complete-payment",
              name: "SPKB Lunas",
              component: SPKBLunas
            },
            {
              path: "spkb-complete-payment/detail/:id",
              name: "SPKB Lunas Details",
              component: SPKBLunasDetail,
              props: true
            }
          ]
        },
        {
          path: "surveyor",
          redirect: "/surveyor/survey-freezer",
          name: "Survey",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [

            {
              path: "survey-freezer",
              name: "Survey Freezer",
              redirect: "/surveyor/survey-freezer/all",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              children: [
                {
                  path: "all",
                  name: "Semua Surver Freezer",
                  component: SurveyFreezer
                },
                {
                  path: "survey-freezer/detail/:id",
                  name: "Semua Surver Freezer Details",
                  component: SurveyFreezerDetail,
                  props: true
                }
              ]
            },
          ]
        },
        {
          path: "/request-freezer",
          redirect: "/request-freezer/all",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Request Freezer",
              component: RequestFreezer
            },
            {
              path: "all/detail/:id",
              name: "Request Freezer Details",
              component: RequestFreezerDetail,
              props: true
            }
          ]
        },
        {
          path: "/freezer-location",
          redirect: "/freezer-location/all",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Freezer Location",
              component: FreezerLocation
            }
          ]
        },
        {
          path: "bank-book",
          name: "Bank Book",
          redirect: "/bank-book/all",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "Bank Book Transaction",
              component: BankBook
            },
            {
              path: "all/detail/:id",
              name: "Bank Book Transaction Details",
              component: BankBookDetail,
              props: true
            }
          ]
        },
        {
          path: "cvo-delivery",
          redirect: "/cvo-delivery/all",
          name: "CVO Delivery",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "CVO Delivery All",
              component: DeliveryCustomer
            },
            {
              path: "all/detail/:id",
              name: "CVO Delivery Details",
              component: CvoDetailActivityDelivery,
              props: true
            }
          ]
        },
         {
          path: "cvo-visit",
          redirect: "/cvo-visit/all",
          name: "CVO Visit",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "all",
              name: "CVO Visit All",
              component: VisitCustomer
            },
             {
              path: "all/detail/:id",
              name: "CVO Visit Details",
              component: CvoDetailActivityVisit,
              props: true
            }
          ]
        },
      ]
    },
    {
      path: "/changepassword",
      redirect: "/changepassword/all",
      name: "",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "all",
          name: "Changepassword",
          component: ChangePassword
        }
      ]
    },

    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        },
        {
          path: "register",
          name: "Register",
          component: Register
        }
      ]
    }
  ]
});

if (location.host === "localhost:8080") {
  //My localhost
  axios.defaults.baseURL = _accessApi.localhost.url;
  axios.defaults.upload_path = _accessApi.localhost.upload_path;
} else if (location.host === "localhost:3001" || location.host === "35.198.220.165:3001") {
  axios.defaults.baseURL = _accessApi.mega.url;
  axios.defaults.upload_path = _accessApi.mega.upload_path;
} else {
  //server
  axios.defaults.baseURL = _accessApi.server.url;
  axios.defaults.upload_path = _accessApi.server.upload_path;
}

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login", "/privacy-policy"];
  const authRequired = !publicPages.includes(to.path);
  const token = localStorage.getItem("token");
  //console.log(authRequired);
  if (authRequired && token === null) {
    next("/login");
  } else if (to.path === "/login" || to.path === "/privacy-policy") {
    //console.log(to.path);
    next();
  } else {
    //, { path: to.path, path_name: to.name }
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios
      .post("/authentication/restricted/", { path: to.path })
      .then(response => {
        if (response.data.status === false) {
          alert(response.data.message);
          next("/dashboard");
        }
        next();
      })
      .catch(error => {
        alert("Your session has been expired");
        next("/login");
      });
  }
  //next()
});

//axios.defaults.baseURL = 'http://localhost/mbs-api/public/'

Vue.use(VueAxios, axios);
